import { Box } from '@mui/material';
import { CopilotFormData } from './types';
import { DebouncedTextField } from './DebouncedTextField';

interface Props {
  data: Pick<
    CopilotFormData,
    'rtSummary' | 'finalAutoSummary' | 'transferSummary' | 'autopilotSummary'
  >;
  onChange: (field: keyof CopilotFormData, value: string) => void;
  transferSummaryDisabled?: boolean;
}

/**
 * Renders the editable Copilot summary fields (RT, final auto, transfer).
 * @param props - summary values, change handler, and transfer-disabled flag
 * @example `<CopilotSummariesSection data={...} onChange={...} />`
 */
export function CopilotSummariesSection({ data, onChange, transferSummaryDisabled = false }: Props) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <DebouncedTextField
        label="RT Summary"
        multiline
        minRows={2}
        fullWidth
        size="small"
        value={data.rtSummary}
        onChange={(v) => onChange('rtSummary', v)}
      />
      <DebouncedTextField
        label="Final Auto Summary"
        multiline
        minRows={2}
        fullWidth
        size="small"
        value={data.finalAutoSummary}
        onChange={(v) => onChange('finalAutoSummary', v)}
      />
      <Box sx={{ opacity: transferSummaryDisabled ? 0.5 : 1, pointerEvents: transferSummaryDisabled ? 'none' : 'auto' }}>
        <DebouncedTextField
          label="Agent Transfer Summary"
          multiline
          minRows={2}
          fullWidth
          size="small"
          disabled={transferSummaryDisabled}
          value={data.transferSummary}
          onChange={(v) => onChange('transferSummary', v)}
        />
      </Box>
    </Box>
  );
}

export default CopilotSummariesSection;
